<template>
  <div class="result">
    <transition name="slide-right" v-if="$store.getters['user/isPaid']">
      <v-attention-area type="alert" float class="alert" v-if="answerImageErrors">
        <template slot="content">
          <p class="mb-0" style="font-weight:bold" :key="answerImageErrors">{{answerImageErrors}}</p>
        </template>
      </v-attention-area>
    </transition>
    <v-base-card>
      <template v-slot:heading>
        <div class="result-heading">
          <p class="result-heading__text mr-4">テスト作成</p>
          <p class="result-heading__text">プレビュー</p>
        </div>
      </template>

      <template v-slot:content>
        <v-section-panel useBreak>
          <template v-slot:content>
            <v-container class="py-0" fluid>
              <v-row>
                <v-col :cols="stepCols" class="py-0" v-resize="setStepCols">
                  <v-stepp :stepps="stepps" disabled/>
                </v-col>
              </v-row>
            </v-container>
            <v-container fluid>
              <v-row>
                <v-col cols=6>
                  <v-result-table/>
                </v-col>
                <v-col cols=6 class="pa-0">
                  <v-bar-charts/>
                </v-col>
              </v-row>
            </v-container>

          </template>
        </v-section-panel>

        <v-preview-area :previewImages="previewImages" />

        <v-choice-print-type v-if="$store.getters['user/isFree']"/>

        <template v-if="$store.getters['user/isPaid'] || $store.state.user.isDemo">
          <!-- 観点と配点エリアの表示有無 -->
          <v-choice-use-allot-area />
          <!-- 1枚に収めるか2枚に分けるかの選択肢 -->
          <v-choice-answer-reduction-type v-if="!(selectedSubjectIsSugaku && usedItems.length > 10) && (answerImageErrors || answerReductionType)" />
        </template>


        <!-- 確定ボタン -->
        <v-btn color="gray" to="/teacher/change">問題差し替え画面へ戻る</v-btn>
        <!-- 途中保存(mounted時にstep更新しているので保存処理は不要→ここでは見た目上のボタンを表示、空の関数を渡す) -->
        <v-save-button :save-fnc="() => {}"/>
        <!-- プレビュー更新ボタン -->
        <v-btn
          class="ml-3"
          color="#4989d1"
          style="color: white;"
          @click="previewAllUpdate()"
        >
          プレビュー更新
        </v-btn>
        <v-btn color="secondary" @click="openConfirmDialog" class="ml-3">次へ</v-btn>
      </template>
    </v-base-card>

    <!-- 確認ダイアログ -->
    <v-confirm-dialog
      ref="confirm"
      title="解答用紙"
      message="「１枚で縮小をかける」「両面印刷で縮小をかけない」 のどちらにするかを確認して、選択されましたでしょうか。（特に、図版が小さい場合は、「両面印刷で縮小をかけない」をご選択ください）"
      buttonMessage="はい"
      cancelButtonMessage="いいえ"
      @confirm="toScoreSetting"
    />
  </div>
</template>

<script>
import VBaseCard from '@/components/molecules/BaseCard'
import VSectionPanel from '@/components/molecules/SectionPanel'
import VResultTable from '@/components/molecules/ResultTable'
import VStepp from '@/components/molecules/Stepp'
import VBarCharts from '@/components/organizms/BarCharts'
import VPreviewArea from '@/components/molecules/PreviewArea'
import VAttentionArea from '@/components/molecules/AttentionArea'
import VSaveButton from '@/components/molecules/SaveButton'
import VChoiceAnswerReductionType from '@/components/molecules/ChoiceAnswerReductionType'
import VChoiceUseAllotArea from '@/components/molecules/ChoiceUseAllotArea'
import VChoicePrintType from '@/components/molecules/ChoicePrintType'
import VConfirmDialog from '@/components/atoms/ConfirmDialog'
import config from "../../config"
import { getStepCols } from '../../plugins/responsive'
import { mapGetters } from 'vuex'

export default {
  components: {
    VBaseCard,
    VSectionPanel,
    VResultTable,
    VStepp,
    VBarCharts,
    VPreviewArea,
    VAttentionArea,
    VSaveButton,
    VChoiceAnswerReductionType,
    VChoiceUseAllotArea,
    VChoicePrintType,
    VConfirmDialog
  },

  data: () => ({
    stepps: [
      {no: 1, text: '問題差し替え', to: '/teacher/change', complete: true, editable: false},
      {no: 2, text: 'プレビュー', to: '/teacher/result', complete: false, editable: false},
      {no: 3, text: '配点設定', to: '/teacher/score_setting', complete: false, editable: false},
      {no: 4, text: 'テスト登録', to: '/teacher/regist_exam', complete: false, editable: false},
    ],
    stepCols: getStepCols()
  }),

  computed: {
    ...mapGetters([
      'selectedSubjectIsSugaku',
    ]),
    shoAnswerReductionType() {
      if (this.$store.getters['user/isFree']) return false

      return
    },
    answerImageErrors(){
      return this.$store.state.sheet.answerImageErrors
    },
    answerReductionType(){
      return this.$store.state.sheet.answerReductionType
    },
    previewImages() {
      const questionFilePaths = this.$store.state.sheet.questionImages
      const answerSheetFilePaths = this.$store.state.sheet.answerSheetImages
      const answerFilePaths = this.$store.state.sheet.answerImages
      const baseURL = this.$axios.defaults.baseURL

      return {
        question: {
          name: '問題',
          data: questionFilePaths.map(path => { return { src: baseURL + path, w: 1800, h: 1200 } })
        },
        answerSheet: {
          name: '解答用紙',
          data: answerSheetFilePaths.map(path => { return { src: baseURL + path, w: 1800, h: 1200 } })
        },
        answer: {
          name: '解答',
          data: answerFilePaths.map(path => { return { src: baseURL + path, w: 1800, h: 1200 } })
        },
      }
    },
    usedItems: {
      get() {
        return this.$store.state.sheet.usedItems
      },
      set(value) {
        this.$store.commit('sheet/setIsUpdate', {type: 'all', isUpdate: true})
        this.$store.commit('sheet/setUsedItems', {
          usedItems: value
        })
      }
    }
  },
  async mounted() {
    const isUpdate = this.$store.getters['sheet/getIsUpdate'].all
    if (isUpdate) this.$app.$refs.loading.open({type: 'print', message: 'プレビュー作成中'})
    // 最小縮小率に達した時の解答用紙の縮小方法をクリア
      const answerReductionType = this.selectedSubjectIsSugaku && this.usedItems.length > 10 ? '2' : null
    if (isUpdate)this.$store.commit('sheet/setAnswerReductionType', { answerReductionType: answerReductionType })
    const targetSheetId = this.$store.state.sheet.sheetContentPages.id
    const params = {
      sheet: {
        step: config.step.PREVIEW,
      }
    }
    await this.$axios.put('/api/v1/teacher/sheets/' + targetSheetId, params)
    await this.$store.dispatch('sheet/getSheetImages', {params:{type:'all'}})
    if (isUpdate) this.$app.$refs.loading.close({})
  },

  methods: {
    setStepCols() {
      this.stepCols = getStepCols()
    },
    openConfirmDialog() {
      if (this.$store.getters['user/isPaid'] || this.$store.state.user.isDemo) this.$refs.confirm.open()
      else this.toScoreSetting()
    },
    toScoreSetting() {
      this.$router.push('/teacher/score_setting')
    },
    async previewAllUpdate() {
      // 強制的に更新するためにisUpdateをtrueにする
      this.$store.commit('sheet/setIsUpdate', {type: 'all', isUpdate: true})
      this.$app.$refs.loading.open({type: 'print', message: 'プレビュー更新中'})
      // 最小縮小率に達した時の解答用紙の縮小方法をクリア
      const answerReductionType = this.selectedSubjectIsSugaku && this.usedItems.length > 10 ? '2' : null
      this.$store.commit('sheet/setAnswerReductionType', { answerReductionType: answerReductionType })
      const targetSheetId = this.$store.state.sheet.sheetContentPages.id
      const params = {
        sheet: {
          step: config.step.PREVIEW,
        }
      }
      await this.$axios.put('/api/v1/teacher/sheets/' + targetSheetId, params)
      await this.$store.dispatch('sheet/getSheetImages', { params: { type:'all' } })
      this.$app.$refs.loading.close({})
    },
  },

  watch: {
    dialog(now) {
      if (!now) this.dialogImage = null;
    }
  },
}
</script>

<style lang="stylus" scoped>
.result-btn
  margin-right 10px

.result-heading
  display inline-block

  &__text
    display inline-block

.slide-right
  &-enter
    transform translate(0px, -200px)

    &-active
      transition all .2s ease-out

    &-to
      transform translate(0px, 0px)

  &-leave
    transform translate(0px, 0px)

    &-active
      transition all .2s ease-out

    &-to
      transform translate(0px, -200px)
.alert
  width 89.3%
  position fixed
  top 80px
  z-index 10

</style>
